module.exports = __webpack_public_path__ + "static/media/b-arts-major-3_LR.86e3b856.jpg";